import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { createDestAction } from "../../../../modules/destinations/action";
import DestinationForm from "../DestinationForm";

class CreateInternaDest extends Component {
  state = {
    successMessage: "",
    errorMessage: {}
  };

  handleSubmit = destInfo => {
    this.props.createDestAction(destInfo);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.destCreated && nextProps.destCreated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  render() {
    const { successMessage } = this.state;
    if (successMessage) {
      return <Redirect to="/farmsetup/destinations/internal" />;
    }
    return (
      <DestinationForm
        buttonLabel="Add new destination"
        formLabel="Set up your internal destination"
        handleSubmit={this.handleSubmit}
        type={1}
        MainFarmId={this.props.MainFarmId}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    destCreated: state.destReducer.destCreated,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createDestAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateInternaDest);



// WEBPACK FOOTER //
// ./src/components/private/Destinations/InternalDest/CreateInternalDest.js